// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-modal-modal_card-ENJpj {
  width: 340px;
  min-height: 340px;
  height: auto;
}

.add-product-modal-textField_container-OAXYB, .add-product-modal-select-dmKNP {
  width: 100%;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-products/add-product-modal/add-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  min-height: 340px;\n  height: auto;\n}\n\n.textField_container, .select {\n  width: 100%;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-product-modal-modal_card-ENJpj`,
	"textField_container": `add-product-modal-textField_container-OAXYB`,
	"select": `add-product-modal-select-dmKNP`
};
export default ___CSS_LOADER_EXPORT___;
